<script>
import ProductCard from '@maison/components/product/ProductCard.vue';
import { PhxIcon } from '@phx-styleguides/jlc';
import price from '@phoenix/mixins/price';

export default {
  components: {
    ProductCard,
    PhxIcon,
  },

  mixins: [price],

  props: {
    productPages: {
      type: Array,
      required: true,
    },
    sliderId: {
      type: String,
      required: true,
    },
  },

  mounted() {
    const sliderElement = this.$refs.slider;
    if (sliderElement) {
      Toolkit.slider(sliderElement, {
        slidesPerView: 'auto',
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
      });
    }
  },
};
</script>

<template>
  <div
    :id="sliderId"
    ref="slider"
    class="slider slider--linear"
    role="group"
    :aria-roledescription="$t('Accessibility.carouselRoleDescription')"
  >
    <button type="button" class="btn btn--default btn--icon-only btn--icon slider__nav slider__nav--prev">
      <span class="sr-only">{{ $t('Accessibility.product.discoverMore') }}</span>
      <span class="btn__icon"><phx-icon icon="chevron-left-10" class="icon--10 icon--arrow" bidirectional /></span>
    </button>

    <div class="slider__body" aria-atomic="false" aria-live="polite">
      <div
        v-for="(product, index) in productPages"
        :id="'slide-' + index"
        :key="product.modelReference"
        class="slider__item"
        role="group"
        :aria-roledescription="$t('Accessibility.slideRoleDescription')"
      >
        <product-card
          :name="product.name"
          :collection="product.collection"
          :image="product.image"
          :model-reference="product.modelReference"
          :description="product.description"
          :url="product.url"
          :vat-information="product.vatInformation"
          :price="product.price"
          :labels="product.labels"
          :has-3-d="product.has3D"
          data-cy="item"
        />
      </div>
    </div>

    <button type="button" class="btn btn--default btn--icon-only btn--icon slider__nav slider__nav--next">
      <span class="sr-only">{{ $t('Accessibility.product.discoverMore') }}</span>
      <span class="btn__icon"><phx-icon icon="chevron-10" class="icon--10 icon--arrow" bidirectional /></span>
    </button>

    <div class="slider__footer">
      <div class="slider__scrollbar"></div>
    </div>
  </div>
</template>
